
import FilesystemPathPart from '@/components/Folders/Path/FilesystemPathPart'
import FilesystemPathPartSkeleton from '@/components/Folders/Path/FilesystemPathPartSkeleton'
export default {
    name: 'FilesystemPath',
    components: { FilesystemPathPart, FilesystemPathPartSkeleton },
    computed: {
        folder () {
            return this.$store.getters['folders/getFolder']
        },
        parts () {
            const parts = []
            if (this.$store.getters['folders/isTrash']) {
                parts.push({ id: null, name: this.$t('my folders trash bin') })
            } else {
                for (const part of this.folder?.path ?? [{ id: null, name: 'مجلداتي' }]) {
                    parts.push({ id: part.id, name: part.name })
                }
                if (this.folder?.id) {
                    parts.push({ id: this.folder.id, name: this.folder.name })
                }
            }
            if (this.$store.getters['folders/searchText']) {
                parts.push({ id: null, name: 'نتائج البحث' })
            }

            return parts
        }
    },
    methods: {
        list (id) {
            this.$emit('list', { id })
        }
    }
}
